<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card warnings-log">
        <h4>Warning Log</h4>
        <p class="hint">Every quote value warning, from saves and from the nightly scan, newest first.</p>

        <div class="p-fluid p-formgrid p-grid p-ai-end">
          <div class="p-field p-col-12 p-md-3">
            <label for="logFrom">From</label>
            <Calendar id="logFrom" v-model="filters.from" dateFormat="dd/mm/yy" :showIcon="true" />
          </div>
          <div class="p-field p-col-12 p-md-3">
            <label for="logTo">To</label>
            <Calendar id="logTo" v-model="filters.to" dateFormat="dd/mm/yy" :showIcon="true" />
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label for="logCheck">Check</label>
            <Dropdown id="logCheck" v-model="filters.check" :options="checkOptions" optionLabel="label"
              optionValue="code" placeholder="All checks" />
          </div>
          <div class="p-field p-col-12 p-md-2">
            <Button id="loadWarnings" label="Show" icon="pi pi-search" :disabled="loading" @click="load" />
          </div>
        </div>

        <DataTable id="warningsTable" :value="rows" :loading="loading" dataKey="id" class="p-datatable-sm"
          :paginator="rows.length > 50" :rows="50">
          <template #empty>No warnings in this period.</template>
          <Column field="createdAt" header="Date">
            <template #body="{ data }">{{ when(data.createdAtIso || data.createdAt) }}</template>
          </Column>
          <Column field="check" header="Check">
            <template #body="{ data }">
              <span :title="data.message">{{ checkLabel(data.check) }}</span>
            </template>
          </Column>
          <Column field="source" header="Source">
            <template #body="{ data }">{{ sourceLabel(data.source) }}</template>
          </Column>
          <Column field="sQuoteNo" header="Quote">
            <template #body="{ data }">
              <router-link v-if="data.oppId" :to="enquiryLink(data)" class="quote-link">{{ data.sQuoteNo || ('Enquiry ' + data.oppId) }}</router-link>
              <span v-else>{{ data.sQuoteNo }}</span>
            </template>
          </Column>
          <Column field="versionNo" header="Version"></Column>
          <Column field="userName" header="User"></Column>
          <Column field="value" header="Value" bodyClass="p-text-right" headerClass="p-text-right">
            <template #body="{ data }">{{ money(data.value) }}</template>
          </Column>
          <Column field="comparedValue" header="Compared with" bodyClass="p-text-right" headerClass="p-text-right">
            <template #body="{ data }">{{ money(data.comparedValue) }}</template>
          </Column>
          <Column field="ratio" header="Ratio" bodyClass="p-text-right" headerClass="p-text-right">
            <template #body="{ data }">{{ ratio(data.ratio) }}</template>
          </Column>
          <Column field="userConfirmed" header="Saved anyway">
            <template #body="{ data }">{{ yesNo(data.userConfirmed) }}</template>
          </Column>
          <Column field="emailed" header="Emailed">
            <template #body="{ data }">{{ yesNo(data.emailed) }}</template>
          </Column>
          <Column field="message" header="Message"></Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import WarningsService, { errorMessage } from '@/service/WarningsService'
import { formatCurrency } from '@/utils/money'
import { CHECKS, SOURCES, checkLabel, formatDateTime } from './warningsSettingsForm'

function day(date) {
  return date ? moment(date).format('YYYY-MM-DD') : null
}

export default {
  data: () => ({
    warningsService: new WarningsService(),
    rows: [],
    loading: false,
    filters: {
      from: moment().subtract(30, 'days').startOf('day').toDate(),
      to: moment().startOf('day').toDate(),
      check: null
    },
    checkOptions: [{ code: null, label: 'All checks' }].concat(CHECKS)
  }),
  created() {
    this.load()
  },
  methods: {
    checkLabel,
    load() {
      this.loading = true
      return this.warningsService.getWarnings({ from: day(this.filters.from), to: day(this.filters.to), check: this.filters.check })
        .then(data => { this.rows = Array.isArray(data) ? data : [] })
        .catch(err => {
          this.rows = []
          this.$toast.add({
            severity: 'error',
            summary: 'Not loaded',
            detail: errorMessage(err, 'The warning log could not be loaded.'),
            life: 5000
          })
        })
        .finally(() => { this.loading = false })
    },
    when(value) {
      return formatDateTime(value)
    },
    sourceLabel(source) {
      return SOURCES[source] || source
    },
    enquiryLink(row) {
      return '/enquiries/' + row.oppId + '/detail'
    },
    money(value) {
      return value === null || value === undefined ? '' : formatCurrency(value)
    },
    ratio(value) {
      if (value === null || value === undefined || isNaN(Number(value))) return ''
      return (Math.round(Number(value) * 10) / 10) + '×'
    },
    yesNo(value) {
      return value ? 'Yes' : 'No'
    }
  }
}
</script>

<style scoped>
.warnings-log .hint { color: #6c757d; }
.warnings-log .quote-link { white-space: nowrap; }
/* Alignment (06/10): index.html also loads Bootstrap 4, whose padding utilities p-md-2/3/4
   (with !important) share their names with PrimeFlex's responsive columns, so these columns got
   7-21px of extra padding and sat lower / further in than the full-width fields. Put back the
   PrimeFlex form-grid padding (none above or below, 0.5rem each side) for this screen only. */
.warnings-log .p-formgrid.p-grid > .p-field { padding: 0 0.5rem !important; }
</style>
